import { useState } from 'react';

import dynamic from 'next/dynamic';

import { IconKocAilem, ChevronRight } from '@assets/icons';
import { LoyaltyType } from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { useAuthState } from '@contexts/auth/AuthContext';

const LoyaltyVerifications = dynamic(
  () => import('@components/ui/loyalty-verifications/LoyaltyVerifications'),
  { ssr: false }
);

const LoginRedirectModal = dynamic(
  () =>
    import('@components/ui/loyalty-verifications/helpers').then(
      ({ LoginRedirectModal }) => LoginRedirectModal
    ),
  { ssr: false }
);

import {
  BannerWrapper,
  InfoWrapper,
  InfoText,
  ButtonWrapper,
  StyledButton,
  ImageContainer,
} from './KocAilemBannerStyle';

type KocAilemBannerProps = {
  showInfoText?: boolean;
  hotelListing?: boolean;
};

const KocAilemBanner = ({
  showInfoText = true,
  hotelListing,
}: KocAilemBannerProps) => {
  const [showModal, setShowModal] = useState(false);
  const { loginInfo } = useAuthState();
  const isLoggedIn = !!loginInfo?.token;

  return (
    <BannerWrapper showInfoText={showInfoText}>
      <InfoWrapper>
        <ImageContainer>
          <IconKocAilem />
        </ImageContainer>

        {showInfoText ? (
          <InfoText>
            KoçAilem’lilere Özel Fiyatları Görüntülemek İçin Doğrulama Yapmanız
            Gerekmektedir.
          </InfoText>
        ) : null}
      </InfoWrapper>
      <ButtonWrapper>
        <StyledButton size='large' onClick={() => setShowModal(true)}>
          KoçAilem Doğrula
          <CustomIcon
            icon={ChevronRight}
            paletteColor='scooter'
            fontSize={17}
          />
        </StyledButton>
      </ButtonWrapper>
      {showModal && isLoggedIn ? (
        <LoyaltyVerifications
          hotelListing={hotelListing}
          action={() => setShowModal(false)}
          loyaltyType={LoyaltyType.KOC_AILEM}
          onCancel={() => setShowModal(false)}
        />
      ) : null}
      {!isLoggedIn && showModal ? (
        <LoginRedirectModal
          kocAilemControl={true}
          onCancel={() => setShowModal(false)}
          loyaltyType={LoyaltyType.KOC_AILEM}
        />
      ) : null}
    </BannerWrapper>
  );
};

export default KocAilemBanner;
